export default `#JSGF V1.0;

grammar actions;

public <action> = start | stop | pause | resume | play | delete | add | insert | create | remove | drag | move | drag | brush;`;
